import { useEffect, useRef } from "react"
import * as am5 from "@amcharts/amcharts5"
import * as am5xy from "@amcharts/amcharts5/xy"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import { Box, Card, CardContent, Typography } from "@mui/material"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"

export default function LineChartComponent({ data, title = "Rendimiento" }) {
  const chartRef = useRef(null)

  useEffect(() => {
    if (!chartRef.current || !data || data.length === 0) return

    const root = am5.Root.new(chartRef.current)
    root.setThemes([am5themes_Animated.new(root)])

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        paddingLeft: 0,
        paddingRight: 20,
      }),
    )

    // X-Axis
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "date",
        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 50,
        }),
      }),
    )
    xAxis.data.setAll(data)

    // Y-Axis - Calcular el máximo dinámicamente
    const maxValue = Math.max(
      ...data.flatMap(d => [
        d.messagesSent || 0,
        d.messagesDelivered || 0,
        d.messagesRead || 0,
        d.responses || 0
      ])
    )
    
    // Agregar un 20% de margen al máximo
    const yAxisMax = Math.ceil(maxValue * 1.2) || 10

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: yAxisMax,
        strictMinMax: true,
        renderer: am5xy.AxisRendererY.new(root, {}),
      }),
    )

    const createSeries = (name, field, color) => {
      const series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name,
          xAxis,
          yAxis,
          valueYField: field,
          categoryXField: "date",
          stroke: am5.color(color),
          fill: am5.color(color),
          tooltip: am5.Tooltip.new(root, {
            labelText: "{name}: {valueY}"
          })
        }),
      )
      series.strokes.template.setAll({ strokeWidth: 2 })
      
      // Agregar bullets (puntos) en cada dato
      series.bullets.push(function() {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 4,
            fill: series.get("fill")
          })
        })
      })
      
      series.data.setAll(data)
    }

    createSeries("Mensajes enviados", "messagesSent", "#e91e63")
    createSeries("Mensajes entregados", "messagesDelivered", "#5e35b1")
    createSeries("Mensajes leídos", "messagesRead", "#00bcd4")
    createSeries("Respuestas", "responses", "#333333")

    // Legend
    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        layout: root.horizontalLayout,
      }),
    )
    legend.data.setAll(chart.series.values)

    return () => {
      root.dispose()
    }
  }, [data])

  return (
    <Card sx={{ boxShadow: 2, height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "16px" }}>
            {title}
          </Typography>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: "#757575" }} />
        </Box>
        <div ref={chartRef} style={{ width: "100%", height: "350px" }} />
      </CardContent>
    </Card>
  )
}